import { render, staticRenderFns } from "./loadp.vue?vue&type=template&id=b976ee74&scoped=true&"
import script from "./loadp.vue?vue&type=script&lang=js&"
export * from "./loadp.vue?vue&type=script&lang=js&"
import style0 from "./loadp.vue?vue&type=style&index=0&id=b976ee74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b976ee74",
  null
  
)

export default component.exports